import {useSyncedState} from '@wandb/weave/common/util/hooks';
// @todo: Migrate to 'Select' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Select} from '@wandb/weave/components/Form/Select';
import React, {FC} from 'react';
import {SingleValue} from 'react-select';

import {useStatsigGateWorkspaceConsolidation} from '../../../../../util/rampFeatureFlags';
import {useSingleRunModeContext} from '../../../../MultiRunWorkspace/SingleRunMode';
import {
  Axis,
  MediaBrowserPanelConfig,
} from '../../../../PanelMediaBrowser/common';
import {
  AxisOption,
  getAxisOptions,
} from '../../../../PanelMediaBrowser/PanelSettings';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

type AxisDropdownProps = {
  initialValue: Axis;
  onSelectOption: (option: Axis) => void;
  title: string;
  configField: keyof MediaBrowserPanelConfig;
};

export const AxisDropdown: FC<AxisDropdownProps> = ({
  initialValue,
  onSelectOption,
  title,
  configField,
}) => {
  const {unsetConfigField} = useMediaSettingsDrawerContext();

  const {isSingleRun} = useSingleRunModeContext();
  const isWorkspaceConsolidationEnabled =
    useStatsigGateWorkspaceConsolidation();
  const excludeRunOption = isSingleRun && !isWorkspaceConsolidationEnabled;
  const axisOptions = getAxisOptions(excludeRunOption);

  const {state: selectedOption, setState: setSelectedOption} =
    useSyncedState<Axis>({
      stateToSyncWith: initialValue,
      setStateToSyncWith: onSelectOption,
    });
  const onChangeDropdown = (option: SingleValue<AxisOption>) => {
    if (option) {
      setSelectedOption(option.value);
    }
  };
  return (
    <div className="flex flex-col" data-test={`${title}-dropdown`}>
      <SettingTitle
        title={title}
        configField={configField}
        unsetConfigField={() => unsetConfigField(configField)}
      />
      <Select<AxisOption>
        className="w-full"
        aria-label={title}
        options={axisOptions}
        getOptionLabel={option => option.text}
        value={axisOptions.find(option => option.value === selectedOption)}
        onChange={onChangeDropdown}
      />
    </div>
  );
};
